import { FoodsIcon } from "@foodpilot/foods";
import { useState } from "react";
import { Loading } from "src/components/utils/Loading";
import { downloadFile } from "src/utils/download";
import { CellTable } from "src/api/client-api/documentation/types";
import { StyledIconButton, StyledGridText } from "./styles/DocumentationListGridColumns";
import i18next, { t } from "i18next";

export type ColumnsProps = {
    canView: boolean;
    canDelete: boolean;
};

export const columns = ({ canView, canDelete }: ColumnsProps) => [
    {
        accessorKey: "name",
        id: "name",
        header: t("documentation.list.name", "Name"),
        enableResizing: true,
        grow: true,
        enableSorting: false,
        Cell: ({ row }: CellTable) => {
            const name = row.original.name ?? row.original.title ?? "";
            return <StyledGridText>{name.charAt(0).toUpperCase() + name.slice(1)}</StyledGridText>;
        },
    },
    {
        accessorKey: "createdAt",
        id: "createdAt",
        header: t("documentation.list.date", "Date"),
        size: 158,
        grow: false,
        enableResizing: false,
        defaultSortDesc: true,
        Cell: ({ row }: CellTable) => {
            if (!row.original.createdAt) return "-";
            const date = new Date(row.original.createdAt);
            const currentLanguage = i18next.language;

            return (
                <StyledGridText>{`${date.toLocaleDateString(currentLanguage ?? undefined)} ${date.toLocaleTimeString(
                    currentLanguage ?? undefined,
                    {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                    },
                )}`}</StyledGridText>
            );
        },
    },
    {
        id: "mrt-row-actions",
        header: t("common.actions.download", "Download"),
        size: 100,
        grow: false,
        enableResizing: false,
        Cell: ({ row }: CellTable) => {
            const [isDownloading, setIsDownloading] = useState(false);

            const handleDownload = async () => {
                if (!row.original.url) return;

                setIsDownloading(true);
                try {
                    await downloadFile({
                        url: row.original.url,
                        filename: row.original.name || row.original.title || "",
                        mimeType: row.original.mimeType,
                    });
                } catch (error) {
                    console.error("Error downloading file:", error);
                } finally {
                    setIsDownloading(false);
                }
            };

            return (
                <>
                    {canView && (
                        <StyledIconButton
                            size="small"
                            onClick={() => handleDownload()}
                            disabled={isDownloading || !row.original.url}
                        >
                            {isDownloading ?
                                <Loading size={14} />
                            :   <FoodsIcon icon="exportDownload" size={2} />}
                        </StyledIconButton>
                    )}
                </>
            );
        },
    },
];
